import { createSelector } from 'reselect';
import get from 'lodash/get';

import { countryCode, currencyCode } from 'Helpers/Geo/Country';
import waitForSentry from 'Helpers/Sentry/wait-for-sentry';
import calculateOrder from 'Redux/reselects/order-calc/calculate-cart';

export const cartStateSelector = state => state.cart;
export const pickAndMixAllSelector = state => state.pickAndMix.all;
const voucherSelector = state => state.voucher;

// Report each order-calc failure once per page load, not on every recompute
const reportedOrderCalcErrors = new Set();

export const reportOrderCalcError = (error, extra) => {
  // waitForSentry reads window, which the server does not have
  if (typeof window === 'undefined') return;
  if (reportedOrderCalcErrors.has(error.message)) return;
  reportedOrderCalcErrors.add(error.message);

  waitForSentry(Sentry => Sentry.captureException(error, { extra }));
};

/**
 * The module calculation, once for each change of the cart, the pick and mix
 * promotions or the voucher. Every reader of the cart (cart-readers.js,
 * line-view.js, cart-display.js, CheckoutUtils) derives from this selector, so
 * the module runs once for each change.
 *
 * Returns { order, error, now }: `order` is the module order (integer minor
 * units) and `error` is null, or `order` is null and `error` is an Error (it
 * is already reported). See calculate-cart.js.
 */
export default createSelector(
  cartStateSelector,
  pickAndMixAllSelector,
  voucherSelector,
  (cart, pickAndMixAll, voucherPassed) => calculateOrder({
    cart,
    pickAndMixAll,
    voucher: get(voucherPassed, 'voucher', {}),
    currencyCode,
    countryCode,
    now: Date.now(),
    reportError: reportOrderCalcError,
  }),
);
